module.exports = __webpack_public_path__ + "img/catnip-400px.00d447ed.png";